import { styled } from '@mui/material'
import Button from '@mui/material/Button'

const ContainedButton = styled(Button)<{ isDelete?: boolean }>(({ theme, isDelete }) => ({
   borderRadius: 3,
   textTransform: 'uppercase',
   fontSize: 11,
   fontWeight: 'bold',
   cursor: 'pointer',
   backgroundColor: isDelete ? theme.palette.error.dark : theme.palette.primary.light,
   ...(isDelete && {
      '&:hover': {
         backgroundColor: theme.palette.error.darker,
      },
   }),
   color: 'white',
}))

export default ContainedButton
